import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/user'
import { computed } from 'vue'
import { ADMIN_ROLES } from '@/util/constants'

function useUserStateHandler() {
  const { user, hasSelectedRole, hasSelectedShift, hadSelectedShift } = storeToRefs(useUserStore())

  const isAdmin = computed(() =>
    user.value?.currentRole ? ADMIN_ROLES.includes(user.value.currentRole) : false
  )

  const hasSelectedRoleOrShift = computed(() => hasSelectedRole.value || hasSelectedShift.value)

  return {
    isAdmin,
    hasSelectedRoleOrShift,
    hasSelectedShift,
    hadSelectedShift
  }
}

export default useUserStateHandler
